// SignupSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { InitialSignUpProps } from '../../../interfaces/ISignUp';

const initialState: InitialSignUpProps = {
  currentPage: 0,
  userData: {
    email: '',
    password: '',
    confirmPassword: '',
    preferredName: '',
    firstName: '',
    lastName: '',
    address: '',
    userType: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
    phone: '',
    mobileNumber: '',
  },
};

const signUpSlice = createSlice({
  name: 'SignupSlice',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.userData = { ...state.userData, ...action.payload };
    },
    clearUserData: (state) => {
      state.currentPage = 0;
      state.userData = {
        email: '',
        password: '',
        confirmPassword: '',
        preferredName: '',
        firstName: '',
        userType: '',
        lastName: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        country: '',
        phone: '',
        mobileNumber: '',
      };
    },
  },
});

export const { setUserData, clearUserData } = signUpSlice.actions;
export default signUpSlice.reducer;
